<template>
  <div class="guideDialog-container">
    <el-dialog
        title="提问引导"
        :visible.sync="show"
        width="1200px"
        :before-close="handleClose">
      <div class="dialog-inner">
        <div class="dialog-left-inner">
          <div :class="type === 5? 'menu-activity':'menu'" @click="change(5)">全部</div>
          <div :class="type === 0? 'menu-activity':'menu'" @click="change(0)">写作助手</div>
          <div :class="type === 1? 'menu-activity':'menu'" @click="change(1)">资料整理</div>
          <div :class="type === 2? 'menu-activity':'menu'" @click="change(2)">知识学习</div>
          <div :class="type === 3? 'menu-activity':'menu'" @click="change(3)">工作生产力</div>
          <div :class="type === 4? 'menu-activity':'menu'" @click="change(4)">日常生活</div>
        </div>
        <div class="dialog-right-inner">
          <div class="text-inner" v-if="type === 5" v-for="(item,index) in list" :key="index">
            <div class="copy" @click="copy(index)">复制</div>
            <div class="title">{{item.title}}</div>
            <div class="textAndmessage">
              <div class="text" :id="`copyInner${index}`" v-html="item.content"></div>
              <div class="message">{{item.tip}}</div>
            </div>
          </div>
          <div class="text-inner" v-for="(item,index) in list[type].prompts" :key="index">
            <div class="copy" @click="copy(index)">复制</div>
            <div class="title">{{item.title}}</div>
            <div class="textAndmessage">
              <div class="text" :id="`copyInner${index}`" v-html="item.content"></div>
              <div class="message">{{item.tip}}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {PROMPT_JSON} from '@/static/js'
export default {
  data(){
    return{
      type:0,
      list:PROMPT_JSON
    }
  },
  props:[
      'show'
  ],
  methods:{
    handleClose(){
      this.$emit('showGuide',false)
    },
    change(num){
      this.type = num
      if(num === 5){
        this.list = []
        PROMPT_JSON.forEach(item =>{
          item.prompts.forEach(item2 =>{
            this.list.push(item2)
          })
        })
      }else{
        this.list = PROMPT_JSON
      }
    },
    copy(e){
      let str = 'copyInner' + e
      let dom = document.getElementById(str)
      const input = document.createElement('input');
      input.id = 'copy'
      document.body.appendChild(input);
      input.setAttribute('value',dom.innerText);
      input.select();
      document.execCommand('copy', true);
      document.body.removeChild(copy)
      this.$emit('copyText',dom.innerText)
      this.$message({
        message:'复制成功',
        type:'success'
      })
    }
  }
}
</script>

<style lang="less">
.guideDialog-container{
  .el-dialog{
    border-radius: 10px;
    height: calc(79%);
    .el-dialog__title{
      font-size: 18px;
      font-family: AlibabaPuHuiTiM;
      color: #303133;
    }
    .el-dialog__body{
      height: calc(100% - 54px);
      padding: 0;
    }
    .dialog-inner{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .dialog-left-inner{
        height: 100%;
        background: #F5F7FA;
        .menu{
          width: 210px;
          height: 24px;
          font-size: 15px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          line-height: 24px;
          padding: 10px 0 10px 20px;
          cursor: pointer;
        }
        .menu-activity{
          width: 210px;
          height: 24px;
          font-size: 15px;
          font-family: AlibabaPuHuiTiM;
          color: #2081E2;
          line-height: 24px;
          padding: 10px 0 10px 20px;
          background: #FFFFFF;
          cursor: pointer;
        }
      }
      .dialog-right-inner{
        width: 100%;
        height: calc(100% - 30px);
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        padding: 0 0 20px 20px;
        overflow-y: auto;
        .text-inner{
          width: 270px;
          height: 232px;
          background: #FFFFFF;
          box-shadow: 0 2px 6px 0 rgba(0,0,0,0.1);
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          padding: 20px 10px;
          margin-bottom: 20px;
          margin-right: 20px;
          position: relative;
          .copy{
            position: absolute;
            top: 0;
            right: 0;
            width: 40px;
            lie-height: 20px;
            background: #3A4A8A;
            border-radius: 0px 8px 0px 8px;
            font-size: 12px;
            font-family: AlibabaPuHuiTiM;
            color: #FFFFFF;
            text-align: center;
            cursor: pointer;
          }
          .title{
            font-size: 18px;
            font-family: AlibabaPuHuiTiM;
            color: #606266;
            margin-bottom: 8px;
          }
          .textAndmessage{
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            .text{
              font-size: 14px;
              font-family: AlibabaPuHuiTiR;
              color: #303133;
            }
            .message{
              font-size: 13px;
              font-family: AlibabaPuHuiTiR;
              color: #909399;
            }
          }
        }
      }
    }
  }
}
</style>
